import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setToast } from '../store/slices/toastSlice';
import { setUser } from '../store/slices/userSlice';

const INACTIVITY_TIMEOUT = 15 * 60 * 1000; 

export const useInactivityTimer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const timeoutRef = useRef<NodeJS.Timeout>();

  const resetTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      // Clear session storage
      sessionStorage.clear();
      
      // Clear user state
      dispatch(setUser({ 
        expires: null, 
        refreshToken: null, 
        roles: null, 
        token: null, 
        user: null 
      }));

      // Show logout message
      // dispatch(
      //   setToast({
      //     message: "Session expired due to inactivity",
      //     severity: "warning",
      //     open: true,
      //   })
      // );

      // Redirect to login page
      navigate('/auth/login');
    }, INACTIVITY_TIMEOUT);
  };

  useEffect(() => {
    // Events to track
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];

    // Add event listeners
    events.forEach(event => {
      window.addEventListener(event, resetTimer);
    });

    // Initial timer setup
    resetTimer();

    // Cleanup
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      events.forEach(event => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, []);
}; 